module.exports = __webpack_public_path__ + "img/bgTitle5.0d5fd6cd.png";